import { Box } from '@chakra-ui/react';

/**
 * The card surface, in one place.
 *
 * Every panel that sits on the page background as a distinct sheet of paper
 * uses this: white surface, hairline border, soft shadow so it reads as lifted
 * rather than outlined. Spread it when a component already needs a plain Box
 * (`<Box {...cardSurface} />`); otherwise prefer the <Card> component below.
 */
export const cardSurface = {
  bg: 'redesign.bg.surface',
  border: '1px solid',
  borderColor: 'redesign.border',
  borderRadius: 'xl',
  boxShadow: 'card',
};

/**
 * A card. Any prop overrides the default surface, so padding, radius and
 * spacing stay the caller's business.
 */
export default function Card({ children, ...props }) {
  return (
    <Box {...cardSurface} {...props}>
      {children}
    </Box>
  );
}
